import React from 'react'
import { Link } from 'react-router-dom';

function Nav() {
    return (
        <div>
            <nav className="nav-main mainmenu-nav d-none d-xl-block">
                <ul className="mainmenu">
                    <li>
                        <Link className="nav-item" to={'/Home'}>
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link className="nav-item" to={'/sobrenos'}>
                            Sobre Nós
                        </Link>
                    </li>

                    {/* === MENU SERVIÇOS ATUALIZADO === */}
                    <li className="has-droupdown">
                        <Link className="nav-link" to="/servicos">
                            Serviços
                        </Link>

                        <ul className="submenu menu-link3">
                            <li>
                                <Link className="sub-menu-link" to="/servicos">
                                    Nossas Soluções (Ver Todas)
                                </Link>
                            </li>
                            <li>
                                <Link className="sub-menu-link" to="/servicos/credito-empresarial">
                                    Crédito Empresarial
                                </Link>
                            </li>
                            <li>
                                <Link className="sub-menu-link" to="/servicos/agro">
                                    Agro
                                </Link>
                            </li>
                            <li>
                                <Link className="sub-menu-link" to="/servicos/seguros">
                                    Seguros
                                </Link>
                            </li>
                            <li>
                                <Link className="sub-menu-link" to="/servicos/credito-carbono">
                                    Crédito de Carbono
                                </Link>
                            </li>
                            <li>
                                <Link className="sub-menu-link" to="/servicos/inteligencia-mercado">
                                    Inteligência de Mercado
                                </Link>
                            </li>
                        </ul>
                    </li>

                    <li>
                        <Link to={'/portfolio'}>Portfólio</Link>
                    </li>

                    <li>
                        <Link className="nav-item" to={'/faq'}>
                            Faq
                        </Link>
                    </li>
                    <li>
                        <Link className="nav-item" to={'/Contato'}>
                            Contato
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Nav;